/**
 * Insurance Leads Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import { AsyncManageResidenceAppointmentsComponent } from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      {/* <Redirect exact from={`${match.url}/`} to={`${match.url}/home`} /> */}
      {/* <Route
        path={`${match.url}/view-all`}
        component={AsyncManageResidenceAppointmentsComponent}
      /> */}
    </Switch>
  </React.Fragment>
);

export default Forms;
